<template>
  <div id="app">
    <header v-if="showNavigation">
      <section class="menu clearfix">


        <div class="logo">
          <router-link :to="{name:routeComponent}" ><img src="./assets/ikude_logo.png" alt="Ikude"></router-link>
        </div>

        <div class="logo_mobile">
          <div class="logo_mobile_inner">
            <router-link :to="{name:routeComponent}" ><img src="./assets/ikude_logo.png" alt="Ikude"></router-link>
          </div>
        </div>

        <div class="drawer-toggle" role="button" @click="$store.dispatch('toggleSidebar')">
          <div class="bar"></div>
          <div class="bar"></div>
          <div class="bar"></div>
        </div>

        <div class="dropdown">
          <button class="dropbtn">設定</button>
          <div class="dropdown-content">
            <a href="#" @click.prevent="goAccountSettings">アカウント設定</a>
            <a href="#" @click.prevent="goCompanySettings">{{dynamicTitle('companySettings')}}</a>
            <a href="#" @click.prevent="goDriverSettings">ドライバーの編集・追加</a>
            <a href="#" @click.prevent="goSupport">サポートへのお問い合わせ</a>
            <a href="#" @click.prevent="signOut">ログアウト</a>
          </div>
        </div>

        <div class="nav-menu">
          <button class="orderlistbtn" @click="goMap">{{dynamicTitle('allVehicle')}}</button>
          <button class="orderlistbtn" @click="goHome">{{dynamicTitle('orderList')}}</button>

        </div>
      </section>
    </header>


    <!-- Drawer Menu -->
    <div class="sidenav-container">

      <div v-if="toggleSidebar" class="backdrop" @click="$store.dispatch('toggleSidebar')"></div>

      <transition name="slide-side">
        <div v-if="toggleSidebar" class="sidenav">
          <div>
            <ul class="nav-list">
              <li class="nav-item"><router-link @click.native="$store.dispatch('toggleSidebar')" to="/list">{{dynamicTitle('orderList')}}</router-link></li>
              <li class="nav-item"><router-link @click.native="$store.dispatch('toggleSidebar')" to="/map">{{dynamicTitle('allVehicle')}}</router-link></li>
              <li class="nav-item"><router-link @click.native="$store.dispatch('toggleSidebar')" to="/account_settings">アカウント設定</router-link></li>
              <li class="nav-item"><router-link @click.native="$store.dispatch('toggleSidebar')" to="/company_settings">{{dynamicTitle('companySettings')}}</router-link></li>
              <li class="nav-item"><router-link @click.native="$store.dispatch('toggleSidebar')" to="/driver_settings">ドライバーの編集・追加</router-link></li>
              <li class="nav-item"><router-link @click.native="$store.dispatch('toggleSidebar')" to="/support">サポートへのお問い合わせ</router-link></li>
              <li class="nav-item" @click="signOutMobile()">ログアウト</li>
            </ul>
          </div>
        </div>
      </transition>
    </div>


    <router-view/>
  </div>
</template>

<script>
  import {db, auth} from './firebase'
  import AccountSettings from "./pages/AccountSettings";
  import { Slide } from 'vue-burger-menu'  // import the CSS transitions you wish to use, in this case we are using `Slide`

  const words = {
    'dayservice' : {
      'companySettings' : '施設情報設定',
      'allVehicle' : '車両一覧',
      'orderList' : '送迎一覧'
    },
    'bike' : {
      'companySettings' : 'お店情報設定',
      'allVehicle' : '車両一覧',
      'orderList' : '注文一覧'
    },
    'default' : {
      'companySettings' : '企業情報設定',
      'allVehicle' : '車両一覧',
      'orderList' : 'リスト'
    }
  }


  export default {
    name: 'App',

    components: {
      Slide
    },

    data () {
      return {
        windowWidth: window.innerWidth,
        company: null,
        phoneDisplay: false,
        tabletDisplay: false,
      }
    },

    methods: {
      goHome() {
        this.$router.push({name: 'Home'})
      },

      goMap() {
        //this.$router.push({name: 'HomeMap'})
        this.$router.push({name: 'MapDashboard'})
      },

      signOutMobile: function () {
        this.$store.dispatch('toggleSidebar')
        this.signOut()
      },

      signOut: function () {
        auth.signOut().then(() => {
          this.$router.push('/signin')
        })

      },

      goAccountSettings() {
        this.$router.push({name: 'AccountSettings'})
      },

      goDriverSettings() {
        this.$router.push('/driver_settings')
      },

      goCompanySettings() {
        this.$router.push({name: 'CompanySettings'})
      },

      goSupport() {
        //window.location = 'https://goldrushcomputing.com';
        this.$router.push({name: 'Support'})
      },

      /* ダイナミックタイトル */
      dynamicTitle(key){
        if(this.company){
          let type = this.company.type
          var wordSet = words[type]
          if(!wordSet){
            wordSet = words['default']
          }
          return wordSet[key]
        }
        return words['default'][key]
      },

      getCompany () {
        let self = this

        this.$bind('company', db.collection('companies').doc(this.companyId)).then(company => {
          //this.getDrivers(orders, self)
          this.$unbind('company')
        })
      },


    },

    computed: {

      isPhone(){
        return this.windowWidth <= 400;
      },

      isTablet(){
        if(this.windowWidth > 768){
          return false
        }else{
          return this.windowWidth > 400;
        }
      },


      showNavigationForMobile() {
        let componentName = this.$route.name
        if(componentName === 'Login'
          || componentName === 'ResetPassword'
          || componentName === 'Order'
          || componentName === 'Run'
          || componentName === 'LandingPage'
          || componentName === 'Privacy'
          || componentName === 'Terms' ){
          return false
        }else{
          return true
        }
      },

      showNavigation() {
        let componentName = this.$route.name
        if(componentName === 'Login'
          || componentName === 'ResetPassword'
          || componentName === 'Order'
          || componentName === 'Run'
          || componentName === 'LandingPage'
          || componentName === 'Privacy'
          || componentName === 'Terms' ){
          return false
        }else{
          return true
        }
      },

      routeComponent(){
        return 'Home'
      },

      companyId() {
        let coId = this.$store.getters.companyId
        if(coId){
          return coId
        }

        //localStorageに存在したらそれをVuexのstoreに書き込んでリターンする。
        if (localStorage.companyId) {
          this.$store.commit('setCompanyId', localStorage.companyId)
          return localStorage.companyId
        }
      },


      toggleSidebar() {
        return this.$store.getters['toggleSidebar']
      }


    },

    mounted () {
      console.log("app mounted")

      /*
      window.onresize = () => {
        console.log("App on resize", window.innerWidth)


        if(window.innerWidth > 768){
          this.tabletDisplay = false
          this.phoneDisplay = false
        }else if(window.innerWidth > 400){
          this.tabletDisplay = true
          this.phoneDisplay = false
        }else{
          this.tabletDisplay = false
          this.phoneDisplay = true
        }
      }*/


      window.onresize = () => {
        this.windowWidth = window.innerWidth
        console.log("onresize", window.innerWidth)
      }

    },

    updated () {
      if(!this.companyId){
      }else{
        this.getCompany()


      }
    },
  }
</script>

<style>

  /*
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

*/



  body {
    margin: 0;
    padding: 0;
    background-color: #F3F3F3;
    color: #000000;
    font-size: 18px;
    line-height: 2;
    font-family: 游ゴシック体, 'Yu Gothic', YuGothic, 'ヒラギノ角ゴシック Pro', 'Hiragino Kaku Gothic Pro', メイリオ, Meiryo, Osaka, 'ＭＳ Ｐゴシック', 'MS PGothic', sans-serif;
  }



  /* ブラウザの規定スタイルを解除 */
  p,h1,h2,h3,h4,h5,h6 {
    margin-top: 0;
  }

  /* ブラウザの規定スタイルを解除 */
  img {
    vertical-align:bottom;
  }

  /* ブラウザの規定スタイルを解除 */
  ul {
    margin: 0;
    padding: 0;
  }

  a {
    text-decoration: none;
  }

  header {
    width: 100%;
    height: 64px;
    background-color: #5C5C5C;
    /*border-bottom: 1px solid #D6B000;*/

  }

  .menu {
    height: 100%;
  }

  .logo {
    float: left;
    margin-top: 12px;
    margin-left: 40px;
  }

  .logo img{
    width: 140px;
    height: auto;
    vertical-align: middle;
  }

  /* ドロップダウンメニュー */
  .orderlistbtn {
    float: right;
    margin: 10px 20px 0px 0;

    width: 120px;
    background-color: Transparent;
    color: #D2FF00;
    padding: 16px;
    font-size: 16px;
    font-weight: bold;
    border: none;
    outline: none;
  }

  .dropdown {
    float: right;
    margin: 10px 160px 0px 0;
  }

  .dropbtn {
    width: 120px;
    background-color: Transparent;
    color: #D2FF00;
    padding: 16px;
    font-size: 16px;
    font-weight: bold;
    border: none;
    outline: none;
  }

  .dropdown-content {
    display: none;
    position: absolute;
    background-color: #ffffff;
    min-width: 240px;
    right: 10%; /* マップの右上のボタンと重ならないように */
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
    z-index: 1;
  }

  .dropdown-content a {
    padding: 12px 16px;
    text-decoration: none;
    display: block;
    color: #5C5C5C;
    font-size: 16px;
    font-weight: normal;
    text-align: left;
  }

  footer {
    text-align: center;
    color: #000000;
    margin-top: 40px;
    padding: 20px 0;
    background-color: #ffffff;
  }

  footer small {
    font-size: 12px;
  }

  a img:hover {
    opacity: 0.8;
    filter: alpha(opacity=80);
  }

  .dropdown-content a:hover {background-color: #EDF9B9;}

  .dropdown:hover .dropdown-content {display: block;}

  .dropdown:hover .dropbtn {background-color: Transparent;}


  /* レモン色の共通ボタンのスタイル */
  .button {
    background-color: #D2FF00;
    border-style: solid;
    border-color: Transparent;
    border-width: 2px;
    color: #5C5C5C;
    border-radius: 12px;
    padding: 13px 22px 12px 22px;
    font-size: 18px;
    font-weight: normal;
    outline: none;
    margin-top: 20px;
  }

  .button:hover {
    border-style: solid;
    border-width: 2px;
    border-color: #C7D931;
  }

  /* Loading Indicator */
  .loadingBackground{
    position:fixed;
    padding:0;
    margin:0;

    top:0;
    left:0;

    width: 100%;
    height: 100%;
    background:rgba(0,0,0,0.5);
  }

  .loadingDialog {
    /* https://stackoverflow.com/a/14816807/1709287 */
    width: 66px;
    height: 66px;


    position:absolute; /*it can be fixed too*/
    left:0; right:0;
    top:0; bottom:0;

    margin:auto;

    /*this to solve "the content will not be cut when the window is smaller than the content": */
    max-width:100%;
    max-height:100%;
    overflow:auto;
  }

  .clearfix:after {
    content: "";
    display: block;
    clear: both;

  }

  /* モバイル */
  .logo_mobile {
    display: table;
    width: 100px;
    height: 81%;
    margin-left: auto;
    margin-right: auto;
  }

  .logo_mobile_inner {
    display: table-cell;
    width: 100px;
    height: 100%;
    vertical-align: middle;
  }

  .logo_mobile img{
    width: 100px;
    height: auto;
  }


  /* SideNav Layout */
  .sidenav-container {
    height: 100%;
    width: 100%;
  }

  .sidenav {
    height: 100%;
    width: 50%;
    background-color: #F0F0F0;
    z-index: 10000;
    position: fixed;
    top: 0;
    left: 50%;
    box-sizing: border-box;
    padding: 30px;
  }

  .backdrop {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 1000;
    position: fixed;
    top: 0;
    left: 0;
  }

  .slide-side-enter-active,
  .slide-side-leave-active {
    transition: all 0.3s ease-out;
  }
  .slide-side-enter,
  .slide-side-leave-to {
    transform: translateX(200%);
  }

  .nav-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .nav-item {
    margin: 27px 0;
    color: #5C5C5C;
    font-size: 18px;
    font-weight: normal;
  }

  .nav-item a {
    text-decoration: none;
    color: #5C5C5C;
    font-size: 18px;
    font-weight: normal;
  }

  .nav-item a:hover,
  .nav-item a:active{
    color: #b4b4b4;
  }

  .drawer-toggle .bar {
    width: 90%;
    height: 3px;
    background-color: white;

  }

  .drawer-toggle {
    display: flex;
    position:absolute;
    right:15px;
    top:15px;

    justify-self: end;
    flex-direction: column;
    justify-content: space-around;
    height: 28px;
    width: 30px;
    cursor: pointer;

    -webkit-tap-highlight-color:  rgba(255, 255, 255, 0);

  }



  @media (max-width: 1024px) {
    .logo{
      display: none;
    }

    .logo_mobile{
      display: table;
    }

    .nav-menu {
      display: none;
    }

    .dropdown{
      display: none;
    }

    .drawer-toggle {
      display: flex;
    }
  }


  @media (min-width: 1025px) {
    .logo{
      display: block;
    }

    .logo_mobile{
      display: none
    }

    .nav-menu {
      display: block;
    }

    .dropdown{
      display: block
    }

    .drawer-toggle {
      display: none;
    }
  }

</style>



// WEBPACK FOOTER //
// src/App.vue